import React from 'react';
import styled from 'styled-components';
import heroImage from '../assets/hero.webp';

const RSVP_DEADLINE = new Date('2026-05-30T23:59:59');

export default function LandingPage({ onRSVPClick }) {
  const isPastDeadline = new Date() > RSVP_DEADLINE;

  return (
    <PageWrapper>
      <InvitationCard>
        <LeftSection>
          <Title>HER NEXT CHAPTER</Title>

          <Divider />

          <SectionLabel>HOSTED BY</SectionLabel>
          <SectionText>Jessica &amp; Tia</SectionText>

          <Divider />

          <SectionLabel>WHEN</SectionLabel>
          <SectionText>Saturday, June 20</SectionText>
          <SectionText>1:00PM MDT</SectionText>

          <Divider />

          <SectionLabel>WHERE</SectionLabel>
          <SectionText>42 Mahogany Cove SE</SectionText>
          <SectionText>Calgary, AB T3M 2S5</SectionText>

          <Divider />

          <MessageText>
            The wedding is coming (as you may have heard),<br />
            our kudi is getting married — now that's the word.
          </MessageText>
          <MessageText>
            Before the big day and all that will be,<br />
            we gather for joy, laughter, and a little balle balle.
          </MessageText>
          <MessageText>
            Join us for Marissa's bridal shower and toast the bride-to-be in style.
          </MessageText>

          {isPastDeadline ? (
            <DeadlineMessage>RSVP deadline has passed</DeadlineMessage>
          ) : (
            <RSVPButton onClick={onRSVPClick}>RSVP</RSVPButton>
          )}

          <RSVPDeadlineText>Kindly RSVP by May 30, 2026</RSVPDeadlineText>
          <WardrobeText>Wardrobe wisdom: Whimsical, secret garden</WardrobeText>

          <CalendarLink href="/marissa-bridal-shower.ics" download>
            Add to Calendar
          </CalendarLink>
        </LeftSection>

        <RightSection>
          <HeroImage src={heroImage} alt="Champagne glass with pearls and books" />
        </RightSection>
      </InvitationCard>
    </PageWrapper>
  );
}

const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: #E8B4B8;
`;

const InvitationCard = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 1000px;
  width: 100%;
  background: #E8B4B8;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LeftSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px 40px 40px 20px;

  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
    padding: 20px;
    order: 2;
  }
`;

const RightSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  @media (max-width: 768px) {
    order: 1;
    padding: 10px 20px;
  }
`;

const HeroImage = styled.img`
  width: 100%;
  max-width: 450px;
  height: auto;
  border-radius: 4px;
  object-fit: contain;
`;

const Title = styled.h1`
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 400;
  font-size: 2.8rem;
  letter-spacing: 3px;
  color: #5C1A1B;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Divider = styled.hr`
  width: 100%;
  max-width: 350px;
  border: none;
  border-top: 1px solid #8B3A3A;
  margin: 15px 0;

  @media (max-width: 768px) {
    max-width: 280px;
  }
`;

const SectionLabel = styled.span`
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 3px;
  color: #8B3A3A;
  margin-bottom: 4px;
`;

const SectionText = styled.span`
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  font-size: 1.35rem;
  color: #5C1A1B;
  line-height: 1.5;
`;

const MessageText = styled.p`
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  font-size: 1.1rem;
  color: #5C1A1B;
  line-height: 1.6;
  margin-top: 8px;
  max-width: 380px;

  @media (max-width: 768px) {
    max-width: 320px;
  }
`;

const RSVPButton = styled.button`
  margin-top: 25px;
  padding: 12px 50px;
  background: #FFFFFF;
  color: #5C1A1B;
  border: 1px solid #8B3A3A;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 600;
  font-size: 1.1rem;
  letter-spacing: 3px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #5C1A1B;
    color: #FFFFFF;
  }
`;

const DeadlineMessage = styled.p`
  margin-top: 25px;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 0.9rem;
  letter-spacing: 1px;
  color: #8B3A3A;
  font-style: italic;
`;

const RSVPDeadlineText = styled.p`
  margin-top: 18px;
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  font-size: 1.05rem;
  color: #5C1A1B;
`;

const WardrobeText = styled.p`
  margin-top: 6px;
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  font-size: 1.05rem;
  color: #5C1A1B;
`;

const CalendarLink = styled.a`
  margin-top: 18px;
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  font-size: 1.05rem;
  color: #8B3A3A;
  text-decoration: underline;

  &:hover {
    color: #5C1A1B;
  }
`;
